import PropTypes from "prop-types";

export const MoneyType = PropTypes.shape({
  cents_as_part: PropTypes.number,
  cents_total: PropTypes.number,
  dollars_as_part: PropTypes.number,
  user_friendly: PropTypes.string
});
